export const locale = {
  dashboard_origin: "儀表板",
  menu: "選單",
  get_menu_again: "重新獲取選單",
  loading_error: {
    title: "載入錯誤！",
    message: "載入資料時出錯！請重試",
    text: "重試",
  },
  copy_right: {
    year: "1404",
    text1: "本系統所有物質和精神權利受保護，屬於廣告公司",
    text2: "最佳企業家",
    text3: "Sehr Arad，任何複製將受到法律追究。",
  },
  user: "尊貴的用戶",
  hi: "你好",
  exit: "退出",
  go_to_page: "前往頁面",
  show: "顯示",
  until: "至",
  from: "從",
  page: "頁",
  notes: "筆記",
  created_at: "創建日期",
  registration: "註冊",
  edit_contact: "編輯聯絡人",
  cancel: "取消",
  edit: "編輯",
  delete: "刪除",
  contact_info: "聯絡資訊",
  add_birthday: "添加生日",
  contacts: "電話簿",
  last_updated_at: "最後更新",
  added_to_contact: "已添加到聯絡人",
  contact_registered: "您的聯絡人未保存。",
  transaction: "交易",
  write_message: "寫訊息",
  note_title: "筆記標題",
  create_note: "添加筆記",
  are_you_sure_to_delete: "您確定要刪除嗎？",
  last_transaction: "最近交易",
  your_balance: "您的餘額",
  no_transaction: "您還沒有交易記錄！",
  increase_balance: "增加餘額",
  transaction_list: "交易清單",
  withdraw: "提現",
  decrease: "提現",
  deposit: "存款",
  increase: "存款",
  charge: "錢包充值",
  refund: "退款",
  save: "保存",
  reload: "刷新清單",
  shared: "共享",
  list: "清單",
  single_add: "單個添加",
  mass_add: "批量添加",
  excel_add: "Excel 添加",
  added_successfully: "添加成功",
  error_add_phone: "添加號碼時出錯",
  group: {
    add: "添加新組",
    delete: "刪除組",
    edit: "編輯組",
    first: "先添加一個新組。",
  },
  successfully_deleted: "刪除成功",
  notification: {
    text: "用戶通知",
    new: "新訊息",
    messages: "訊息",
    events: "事件",
    no_new_message: "沒有新訊息！",
    show_all: "顯示全部",
    no_new_event: "沒有新事件！",
    go_to_user: "前往用戶",
    watched: "已查看",
  },
  locking_for_service: "您在尋找哪項服務？",
  service_name: "輸入您想要的服務名稱...",
  invite: {
    title: "向朋友介紹系統。",
    gift: "禮物",
    get: "領取。",
    phone: "輸入號碼。",
    invite: "邀請！",
    got_it: "明白了",
    get_gift: "領取禮物",
    success: "您的邀請訊息已成功發送。",
    wrong_number: "請輸入正確號碼。",
  },
  ticker: {
    text: "我們隨時為您服務...",
    help: "註冊票據以聯絡支持團隊",
    register: "註冊票據",
  },
  package: {
    title: "活躍套餐",
    no: "您沒有活躍套餐。",
    no_limit: "無限面板",
    day: " 天",
    other: " 其他",
    expiration: "結束 ",
    expired: "已過期 ",
  },
  Loading: {
    Waiting: "請稍等",
    Description: "等待幾秒鐘",
  },
  Questions: {
    Yes: "是",
    No: "否",
  },
  Success: {
    Title: "成功",
    defaultActionText: "明白了",
  },
  Info: {
    Title: "資訊",
    defaultActionText: "明白了",
  },
  Warning: {
    Title: "注意",
    defaultActionText: "明白了",
  },
  Error: {
    Title: "錯誤",
    defaultActionText: "明白了",
  },
  Wallet: {
    Title: "餘額不足",
    defaultActionText: "明白了",
  },
  ConnectionLost: {
    Title: "網際網路連線中斷",
    Subtitle: "請檢查您的網際網路連線",
    Button: "重試",
  },
  emoji: "表情符號",
  text_suggest_free: "文字顧問（免費）",
  select_campaign: "選擇活動",
  short_link: "短連結",
  text_suggest: "文字顧問",
  select_emoji: "選擇表情符號",
  default_text: "預設文字",
  emoji_group: {
    "Smileys & Emotion": "表情與情感",
    "People & Body": "人物與身體",
    "Animals & Nature": "動物與自然",
    "Food & Drink": "食物與飲料",
    "Travel & Places": "旅行與地點",
    Activities: "活動",
    Objects: "物體",
    Symbols: "符號",
    Flags: "旗幟",
  },
  table: {
    index: "序號",
    title: "標題",
    text: "文字",
    select: "選擇",
    next: "下一頁",
    previous: "上一頁",
    rows_per_page: "每頁行數",
    no_data: "無資料顯示",
    search_placeholder: "搜尋",
  },
  modal: {
    success: "成功",
  },
  actions: {
    remove: "移除",
    copyLink: "複製連結",
    operations: "操作",
    edit: "編輯",
    delete: "刪除",
    show: "顯示",
    accept: "確認",
    reject: "拒絕",
    enable: "啟用",
    download: "下載",
    deactive: "停用",
  },

  shortLink: {
    freeShorten: "免費縮短您的連結。",
    clickToSelect: "點擊您想要的連結進行選擇。",
    create: "創建短連結",
    title: "標題",
    titleHint: "為短連結添加名稱。",
    link: "連結",
    linkHint: "輸入您想要的連結。",
    shortenedLink: "縮短連結",
    clickCount: "點擊次數",
    selectDomain: "選擇域名",
  },
  pagination: {
    next: "下一頁",
    previous: "上一頁",
    rowsPerPage: "每頁行數",
    noData: "無資料顯示",
    search: "搜尋",
  },
  validation: {
    titleRequired: "標題必填",
    minLength4: "至少 4 個字元",
    linkRequired: "連結必填",
    mustIncludeHttps: "必須包含 https://",
    invalidLink: "請輸入正確連結。",
  },
  messages: {
    addedSuccessfully: "添加成功。",
    confirmDeleteShortLink: "確認刪除短連結？",
  },
  inputMenu: {
    text: "文字",
    selectUserInfo: "選擇用戶資訊",
  },
  patternDialog: {
    title: "選擇模板/活動",
    change: "更改模板/活動",
    createPattern: "保存新模板",
    createCampaign: "保存新活動",
    tabs: {
      pattern: "選擇模板",
      campaign: "選擇活動",
    },
    empty: "未找到模板，請先保存一個模板。",
    columns: {
      id: "ID",
      type: "類型",
      pattern: "模板",
      static: "固定",
      title: "標題",
      content: "文字",
      status: "狀態",
      rejected: "已拒絕",
      approved: "已批准",
    },
    pagination: {
      next: "下一頁",
      prev: "上一頁",
      rowsPerPage: "每頁行數",
      noData: "無資料顯示",
      search: "搜尋",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "選定訊息：",
    REQUIRED_INPUTS: "必填欄位：",
    SELECTED_CAMPAIGN: "選定活動：",
    CAMPAIGN_ID: "ID",
    PRE_NAME: "前綴名",
    NAME: "姓名",
    MIDDLE_NAME: "中間名",
    LAST_NAME: "姓氏",
    POST_NAME: "後綴名",
    ALIAS: "別名",
    COMPANY: "公司",
    JOB_TITLE: "職位",
    PHONE: "電話",
    BIRTHDAY: "生日",
    DESCRIPTION: "描述",
  },
  CONTACT_GROUP: {
    LIST: "清單",
    ADD: "添加",
    SEARCH: "搜尋",
    INDEX: "序號",
    ID: "ID",
    GROUP_NAME: "組名",
    PARENT: "上級",
    CREATE: {
      GROUP_NAME: "預設組名",
      PARENT_CATEGORY: "上級類別",
      ADD_GROUP: "添加組",
      SUCCESS: "預設組添加成功。",
      ERROR: "添加預設組時出錯！",
      SEARCH: "搜尋",
      TITLE: "標題",
      SEARCH_IN_TITLE: "在標題中搜尋",
      FROM: "從",
      TO: "至",
      BIRTHDAY_FROM: "生日從",
      BIRTHDAY_TO: "至",
      ITEMS_PER_PAGE: "每頁項目數",
      PHONE_COPY: "複製號碼",
      COPY_PHONE: "複製號碼",
      DELETE_CONTACT_GROUP: "從組中刪除聯絡人",
      DELETE_FROM_GROUP_ONLY: "僅從此組刪除聯絡人",
      DELETE_FROM_ALL_GROUPS: "從所有組刪除聯絡人",
      USER: "用戶",
      PHOTO: "照片",
      FULL_NAME: "姓名",
      EMAIL: "電子郵件",
      PHONE_NUMBER: "電話號碼",
      JOB_TITLE_COMPANY: "職位和公司",
      CREATED_AT: "創建時間",
      PHONEBOOK: "電話簿",
      ACTIONS: "操作",
    },
    TITLE: "標題",
    SEARCH_IN_TITLE: "在標題中搜尋",
    FROM: "從",
    TO: "至",
    BIRTHDAY_FROM: "生日從",
    BIRTHDAY_TO: "至",
    ITEMS_PER_PAGE: "每頁項目數",
    PHONE_COPY: "複製號碼",
    COPY_PHONE: "複製號碼",
    DELETE_CONTACT_GROUP: "從組中刪除聯絡人",
    DELETE_FROM_GROUP_ONLY: "僅從此組刪除聯絡人",
    DELETE_FROM_ALL_GROUPS: "從所有組刪除聯絡人",
    USER: "用戶",
    PHOTO: "照片",
    FULL_NAME: "姓名",
    EMAIL: "電子郵件",
    PHONE_NUMBER: "電話號碼",
    JOB_TITLE_COMPANY: "職位和公司",
    CREATED_AT: "創建時間",
    PHONEBOOK: "電話簿",
    ACTIONS: "操作",
  },
  GRADUAL: {
    SEND_GRADUAL: "分階段發送",
    ALLOWED_HINT: "適用於超過 500 個號碼",
    SEND_GRADUAL_OPTION: "分階段發送",
    AFTER_EVERY: "每",
    SEND_SMS: "條簡訊發送？",
    TIME_INTERVAL: "時間間隔",
    SMS_PART: "簡訊數量",
    SMS_PART_HINT: "輸入每批發送的簡訊數量。",
    COUNT_ERROR: "每批簡訊數量不能少於 500！",
  },
  HISTORY: {
    CREATE_NEW: "創建新歷史",
    BACK: "返回",
    TITLE: "歷史標題",
    STEP: "步驟",
    LAST_CALL: "上次通話時間",
    DISCUSSIONS: "進行的討論",
    REMIND_DATE: "提醒時間",
    FOLLOWUP: "下次通話跟進事項",
    SAVE_HISTORY: "保存歷史",
    INDEX: "序號",
    SAVED_BY: "保存者",
    ACTION: "管理",
    MORE_INFO: "更多資訊",
    CREATE_ERROR: "添加客戶歷史時出錯！",
  },
  FORMS: {
    SourceNumber: "源號碼",
    DestinationPhone: "目標號碼",
    Add: "添加",
    SEND_TO_SELECTED_NUMBERS: "發送到選定號碼",
    CHANGE_PATTERN_CAMPAIGN: "更改模板/活動",
    SendTime: "發送時間",
    SELECTED_MESSAGE: "選定訊息",
    REQUIRED_INPUTS: "必填欄位",
    SELECTED: "已選擇",
    ID: "ID",
    SEND: "發送",
    DATE_REQUIRED: "必須選擇日期。",
    TIME_INTERVAL: "時間間隔",
    TIME_INTERVAL_FROM_PREVIOUS: "與上一條訊息的時間間隔",
    Title: "標題",
    LINK: "連結",
    LINK_HINT: "任意",
    LINK_PLACEHOLDER: "範例[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "您的連結縮短後將以 14 個字元顯示（example.ex/any），每條訊息將發送唯一連結。",
    Text: "文字",
    MUST_INCLUDE_PATTERN: "必須包含 {pattern} 表達式",
    INVALID_LINK: "請輸入正確連結",
  },
  ERRORS: {
    VpnDetectedTitle: "請關閉 VPN",
    VpnDetectedSubtitle: "這將使系統運行更好，讓您有更好的體驗。",
    PhoneIsNotValid: "電話號碼無效",
    MaxPhoneLimit: "無法添加超過 50,000 個號碼。",
    NoSelectedLineNumber: "未選擇源號碼。",
    INVALID_TIMER: "請輸入正確時間",
    NoAccess: "您沒有權限",
    PleaseBuyAPlane: "請購買一個套餐",
    NoAccountCharge: "帳戶餘額不足",
    PleaseChargeYourAccount: "請充值您的帳戶",
    Unauthorized: "無權限：請重新登入",
    ServerError: "伺服器錯誤，請稍後重試",
    NetworkError: "網路錯誤：請檢查您的網際網路連線",
    InvalidInput: "無效輸入",
    SessionExpired: "會話已過期，請重新登入",
    TokenInvalid: "無效令牌",
    VpnDetected: "您的 VPN 已開啟，請關閉",
    RequestTimeout: "請求超時，請重試",
    DuplicateEntry: "此項已註冊",
  },

  BUTTONS: {
    DELETE_NUMBERS: "刪除號碼",
    ADD_BULK: "批量添加",
    FROM_FILE: "從檔案",
    More: "更多",
    BuyAPlane: "購買套餐",
    AccountCharge: "帳戶充值",
    OK: "確定",
    Close: "關閉",
    Cancel: "取消",
    Retry: "重試",
    Login: "登入",
    Logout: "退出",
    Save: "保存",
    Submit: "提交",
  },
  GENERAL: {
    row: "序號",
    id: "ID",
    back: "返回",
    manage: "管理",
    SENDING: "發送中",
    RELOAD: "刷新",
    PRINT: "列印",
    DELETE: "刪除",
    SUBMIT: "提交",
    SUCCESSFULLY_ADDED: "添加成功",
    RELOAD: "刷新",
    CANCEL: "取消",
    SUCCESSFULLY_DOWNLOADED: "下載成功",
    Loading: "載入中...",
    NoData: "未找到資料",
    Welcome: "歡迎",
    Profile: "個人資料",
    Settings: "設定",
    Wallet: "錢包",
    Dashboard: "儀表板",
  },

  NOTICES: {
    Attention: "注意",
    MinimumSendWarning:
      '"新聞發送" 使用源號碼發送時，最小數量必須為 {{number}}。',
  },
  contactsTags: {
    select_group: "選擇組",
    create_group: "創建組",
    search: "搜尋",
    add_group: "添加組",
    enter_group_name: "輸入您想要的名稱",
    group_name: "組名",
    cancel: "取消",
    edit: "編輯",
    save: "保存",
    loading_categories: "載入類別中...",
    select_group_and_subgroup: "選擇組和子組",
    add_group_with_subgroups: "添加組及子組",
    add_group_only: "僅添加選定組",
    duplicate_name_error: "名稱已存在",
    added_successfully: "添加成功。",
    confirm_delete_group: "確認刪除組？",
    deleted_successfully: "刪除成功",
    edited_successfully: "編輯成功",
    group_added_successfully: "選定組已成功添加。",
    error_creating_group: "添加預設組時出錯",
    create_default_group: "創建預設組",
    select_default_group: "選擇預設組",
    add_custom_group: "添加自訂名稱組",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "添加電話號碼",
    ADD: "添加",
    SHARE_ACCESS: "選擇以下任意一項，與他人共享您想要的訪問權限。",
    SELECT_ACCESS: "選擇電話簿訪問權限",
    DELETE: "刪除",
    EDIT: "編輯",
    SEND: "發送",
    PERSONS_WITH_ACCESS: "有權限的人",
    REMOVE_ACCESS: "移除權限",
    RETURN: "返回",
    SAVE_CHANGES: "保存更改",
    SHARE_CONTACT_BOOK: "共享電話簿",
    PHONE_VALIDATION: "請輸入正確電話號碼",
    SUCCESS_SHARE: "電話簿共享成功。",
    ERROR_SHARE: "共享電話簿時出錯！",
    PHONE_DUPLICATE: "號碼已添加！",
    CHANGES_SAVED: "更改保存成功。",
    ERROR_SAVING_CHANGES: "保存更改時出錯！",
  },
  CONTACT_SEARCH: {
    SEARCH: "搜尋",
    ADD_NUMBER: "添加號碼",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "每頁",
    FROM: "從",
    TO: "至",
    TOTAL: "總數",
  },
  SUCCESS: {
    DELETED: "刪除成功",
    SUCCESS: "成功",
  },
  CONFIRM: {
    DELETE_BULK: "刪除未保存的號碼？",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "複製您的號碼並點擊",
    COPY_LINK: "複製連結",
    COPY_NUMBER: "複製號碼",
    SEE_PROFILE: "查看個人資料",
  },
  CONTACT_EDIT: {
    EDIT: "編輯",
    DELETE: "刪除",
  },
  CONTACT_MENU: {
    SHARE: "共享",
    PRINT: "列印",
    EXCEL_EXPORT: "匯出到 Excel",
    DELETE: "刪除",
    SUCCESS_DELETE: "刪除成功。",
    ERROR_DELETE: "刪除聯絡人時出錯！",
  },
  CONTACTS: {
    PREFIX: "前綴",
    NAME: "姓名",
    MIDDLENAME: "中間名",
    LASTNAME: "姓氏",
    POSTFIX: "後綴",
    ALIAS: "別名",
    COMPANY: "公司",
    JOBTITLE: "職位",
    PHONE: "電話",
    PHONE_PLACEHOLDER: "範例：8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "添加電子郵件",
    EMAIL: "電子郵件",
    ADD_ADDRESS: "添加地址",
    ADDRESS: "地址",
    PROVINCE: "省",
    CITY: "城市",
    POSTALCODE: "郵政編碼",
    YEAR_OPTIONAL: "年（可選）",
    MONTH: "月",
    DAY: "日",
    ADD_BIRTHDAY: "添加生日",
    ADD_WEBSITE: "添加網站",
    WEBSITE: "網站",
    ADD_DATE: "添加日期",
    DATE: "日期",
    CUSTOM_FIELD: "自訂欄位",
    ADD_CUSTOM_FIELD: "添加自訂欄位",
    NOTE: "描述",
    ADD_NOTE: "添加筆記",
    HOME: "家庭",
    WORK: "工作",
    OTHER: "其他",
    PROFILE: "個人資料",
    BLOG: "部落格",
    HOMEPAGE: "首頁",
    TITLE: "標題",
    BIRTHDAY_ERROR: "請輸入正確日期",
    YEAR_ERROR: "4 位數",
    EMAIL_ERROR: "請輸入正確電子郵件",
    WEBSITE_ERROR: "請輸入正確連結 (website.com)",
    PHONE_ERROR: "請輸入正確電話號碼",
    ADD_HISTORY: "添加歷史",
    HISTORY_LIST: "歷史清單",
    EDIT_CONTACT: "編輯聯絡人",
    SHOW_CONTACT: "顯示聯絡人",
  },
  MONTHS: {
    FARVARDIN: "Farvardin",
    ORDIBEHESHT: "Ordibeheşt",
    KHORDAD: "Khordad",
    TIR: "Tir",
    MORDAD: "Mordad",
    SHAHRIVAR: "Şehrivar",
    MEHR: "Mehr",
    ABAN: "Aban",
    AZAR: "Azar",
    DEY: "Dey",
    BAHMAN: "Bahman",
    ESFAND: "Esfand",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "下載並使用範例 Excel 檔案",
    UPLOAD_TITLE: "上傳檔案",
    DRAG_DROP_TEXT_PART1: "拖放以上傳或",
    DRAG_DROP_TEXT_PART2: "點擊",
    DRAG_DROP_TEXT_PART3: "此處",
    FILE_INPUT_LABEL: "上傳 Excel 檔案",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "連結複製成功！",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "複製連結時出錯。",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "選擇模板/活動",
    BUTTON_EDIT_TEXT: "更改模板/活動",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "保存新模板",
    REGISTER_NEW_CAMPAIGN: "保存新活動",
    CREATE_NEW_HISTORY: "創建新歷史",
    SAVE_HISTORY: "保存歷史",
    SELECT_GROUP: "選擇組",
    CREATE_GROUP: "創建組",
    ADD_GROUP: "添加組",
    SAVE: "保存",
    CREATE_GROUP_SINGULAR: "創建組",
    ADD: "添加",
    SEND: "發送",
    EDIT_PERMISSIONS: "編輯",
    GO_BACK: "返回",
    SAVE_CHANGES: "保存更改",
    GUIDE: "指南",
    START: "開始",
    EDIT: "編輯",
    CANCEL: "取消",
    AUTO_REFRESH: "自動刷新",
    AUTO_REFRESH_SETTINGS: "自動刷新設定",
    BACK: "返回",
  },
  TABS: {
    SELECT_PATTERN: "選擇模板",
    SELECT_CAMPAIGN: "選擇活動",
    LIST: "清單",
    ADD: "添加",
    ADD_CUSTOM_GROUP: "添加自訂名稱組",
    SELECT_DEFAULT_GROUP: "選擇預設組",
  },
  NO_DATA: {
    NO_PATTERN: "未找到模板，請先保存一個模板。",
  },
  TABLE: {
    ID: "ID",
    TYPE: "類型",
    PATTERN: "模板",
    STATIC: "固定",
    TITLE: "標題",
    TEXT: "文字",
    STATUS: "狀態",
    REJECTED: "已拒絕",
    ACCEPTED: "已批准",
    NEXT_BUTTON: "下一頁",
    PREVIOUS_BUTTON: "上一頁",
    ROWS_PER_PAGE_TEXT: "每頁行數",
    NO_DATA_TEXT: "無資料顯示",
    PLACEHOLDER_SEARCH: "搜尋",
    MORE_INFO_ABOUT_ITEM: "關於 {name} 的更多資訊",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "文字",
    SELECT_USER_INFO: "選擇用戶資訊",
  },
  TABLE_CONTROLS: {
    COUNT: "數量",
    SEARCH: "搜尋",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "預設組名",
    PARENT_CATEGORY: "上級類別",
    HISTORY_TITLE: "歷史標題",
    STEP: "步驟",
    LAST_CALL_TIME: "上次通話時間",
    NEGOTIATIONS: "進行的討論",
    REMINDER_TIME: "提醒時間",
    FOLLOW_UP_ITEMS: "下次通話跟進事項",
    GROUP_NAME: "組名",
    SEARCH: "搜尋",
    TITLE: "標題",
    SEARCH_IN_TITLE: "在標題中搜尋",
    FROM: "從",
    TO: "至",
    BIRTHDAY_FROM: "生日從",
    BIRTHDAY_TO: "至",
    COUNT: "數量",
    ADD_PHONE_NUMBER: "添加電話號碼",
  },
  TOAST: {
    Success: "操作成功完成",
    Error: "發生錯誤",
    Warning: "警告：請檢查輸入",
    AUTO_REFRESH_STARTED: "自動刷新已開始。",
    DEFAULT_GROUP_SUCCESS: "預設組添加成功。",
    DEFAULT_GROUP_ERROR: "添加預設組時出錯！",
    ADD_HISTORY_ERROR: "添加客戶歷史時出錯！",
    DUPLICATE_NAME: "名稱已存在",
    TAG_ADDED_SUCCESS: "標籤添加成功。",
    TAG_DELETED_SUCCESS: "標籤刪除成功",
    TAG_EDITED_SUCCESS: "標籤編輯成功",
    GROUPS_ADDED_SUCCESS: "選定組已成功添加。",
    ADD_GROUP_ERROR: "添加預設組時出錯！",
    PHONE_COPIED_SUCCESS: "電話號碼已複製。",
    SUCCESSFULLY_DELETED: "刪除成功",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK: "從電話簿刪除聯絡人時出錯！",
    SHARE_SUCCESS: "電話簿共享成功。",
    SHARE_ERROR: "共享電話簿時出錯！",
    NUMBER_ALREADY_ADDED: "號碼已添加！",
    CHANGES_SAVED_SUCCESS: "更改保存成功。",
    CHANGES_SAVE_ERROR: "保存更改時出錯！",
  },
  HEADERS: {
    GRADUAL_SEND: "分階段發送",
    GRADUAL_SEND_HINT: "（適用於超過 500 個號碼）",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "分階段發送",
    DELETE: "刪除",
    EDIT: "編輯",
    ADD: "添加",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "每 {time} 發送一次訊息嗎？",
  },
  LABELS: {
    TIME_INTERVAL: "時間間隔",
    MESSAGE_COUNT: "訊息數量",
  },
  TIME_TYPES: {
    MINUTE: "分鐘",
    HOUR: "小時",
    DAY: "天",
    WEEK: "週",
    SECOND: "秒",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "輸入每批發送的訊息數量。",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT: "每批訊息數量不能少於 500！",
  },
  TABLE_HEADERS: {
    ROW: "序號",
    TITLE: "標題",
    STEP: "步驟",
    REMINDER_TIME: "提醒時間",
    LAST_CALL_TIME: "上次通話時間",
    RECORDER: "記錄者",
    MANAGEMENT: "管理",
    ID: "ID",
    GROUP_NAME: "組名",
    PARENT: "上級",
    CREATED_AT: "創建時間",
    IMAGE: "照片",
    FULL_NAME: "姓名",
    EMAIL: "電子郵件",
    PHONE_NUMBER: "電話號碼",
    JOB_COMPANY: "職位和公司",
    CREATION_TIME: "創建時間",
    PHONEBOOK: "電話簿",
    ACTIONS: "操作",
    USER: "用戶",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "源號碼",
  },
  MODAL: {
    INFO_TITLE: "注意。",
    INFO_MESSAGE_NEWS_NUMBER: '"{number}" 源號碼發送時，最小數量必須為 1000。',
    CONFIRM_DELETE_GROUP: "確認刪除組？",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "新聞發送",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "系統指南",
    ERROR: "錯誤",
    WARNING: "警告",
    SUCCESS: "成功",
    CONFIRM: "確認",
    SELECT_GROUP: "選擇組",
    CREATE_NEW_GROUP: "創建新組",
    SELECT_GROUP_SUBGROUP: "選擇組和子組",
    CREATE_DEFAULT_GROUP: "創建預設組",
    DELETE_CONTACT_FROM_GROUP: "從組中刪除聯絡人",
    DELETE_CONTACT: "刪除聯絡人",
    SHARE_PHONEBOOK: "共享電話簿",
    SYSTEM_GUIDE: "廣告終端系統指南",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "輸入您想要的名稱",
    SELECT_PERMISSIONS: "為 {name} 電話簿選擇訪問權限：",
    PEOPLE_WITH_ACCESS: "有權限的人",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "載入類別中...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "添加組及子組",
    SELECTED_GROUP_ONLY: "僅添加選定組",
    DELETE_FROM_THIS_GROUP_ONLY: "僅從此組刪除聯絡人",
    DELETE_FROM_ALL_GROUPS: "從所有組刪除聯絡人",
  },
  FILTER_LABELS: {
    ADDRESS: "地址",
    EMAIL: "電子郵件",
    WEBSITE: "網站",
    CUSTOM_FIELD: "自訂欄位",
    DATE: "日期",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION: "選擇以下任意一項，與他人共享您想要的訪問權限。",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "請輸入正確電話號碼",
  },
  LIST_ITEM_TITLES: {
    DELETE: "刪除",
    EDIT: "編輯",
    ADD: "添加",
    REMOVE_ACCESS: "移除權限",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "活動名稱",
    TEXT: "文字",
    MESSAGE: "訊息",
    FOR: "用於",
    SELECT_CAMPAIGN: "選擇活動",
    CLICK_ROW: "點擊您想要的行。",
    NEW: "新建",
    SUBMIT_CAMPAIGN: "保存活動",
    TIME: "時間",
    MESSAGE_COUNT: "訊息數量",
    PAGE_COUNT: "總訊息（頁）",
    PAGE: "頁",
    CANCEL_TEXT: "取消11",
    TRACKABLE_LINK: "可追蹤連結",
    WARNING_TEXT: "請修正選定活動的文字！",
    WARNING_TITLE: "請修正選定活動的標題！",
    WARNING_GAP: "請修正選定活動的時間間隔！",
    WARNING_OPERATOR: "請修正選定活動的運營商！",
    MAX_ITEMS_ERROR: "最多可添加 10 項。",
  },
  ADS: {
    LIVE_SMS: "即時簡訊發送",
    BUY_JOB_DB: "購買職業資料庫",
    SMART_LADDER: "Divar 廣告智能階梯",
    JOB_SMS: "向職業發送簡訊",
    WEB_DESIGN: "網站設計訂單",
    SEO: "網站 SEO 訂單",
    MAP_SMS: "從地圖發送簡訊",
    GRADUAL_LADDER: "Divar 廣告分階段階梯",
    SEO_ALT: "網站 SEO 訂單",
    SITE_SUPPORT: "網站管理和支援",
    CITY_SMS: "城市和省份簡訊發送",
    AUTO_CHAT: "Divar 自動聊天",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "WhatsApp 聯絡",
    TICKET_SUPPORT: "註冊票據",
  },
  INCREASE: {
    PAN: "卡號",
    CVV2: "CVV2",
    MONTH: "月",
    YEAR: "年",
    PIN2: "第二密碼",
    GET_OTP: "獲取第二密碼",
    PAY: "支付",
    INVALID_PAN: "卡號錯誤",
    INVALID_CVV2: "CVV2 錯誤",
  },
  WALLET: {
    CustomCharge: "錢包充值",
    withdrawTitle: "從錢包提現",
    transactionListTooltip: "您的交易清單",
    reloadTooltip: "刷新",
    withdrawTooltip: "從錢包提現",
    AmountLabel: "金額 ",
    SelectAmount: "選擇金額",
    Amount: "金額",
    Currency: "里亞爾",
    GateWay: "支付閘道",
    noGateWay: "未找到閘道",
    Pay: "支付",
    PriceNotInRange: "金額必須在 {min} 和 {max} 之間。",
    ErrorOnRedirectToGateWay: "跳轉到支付閘道時出錯",
    ErrorGeneral: "錯誤",
    MinAmountError: "輸入金額小於最小值。",
    MinBazarAmountError: "金額不能少於 10,000 托曼！",
    BazarSuccessInfo: "支付成功後，您的錢包將在 1-3 分鐘內充值。",
    withdrawableBalance: "可提現餘額",
    withdrawFee: "提現手續費：50,000 里亞爾！",
    selectAccount: "選擇帳戶",
    addAccount: "添加帳戶",
    submitWithdraw: "確認提現",
    accountRequiredInfo: "所有資訊必填。",
    ownerName: "帳戶持有人姓名",
    ownerLastName: "姓氏",
    bankName: "銀行名稱",
    accountNumber: "帳戶號碼",
    cardNumber: "卡號",
    sheba: "Sheba 號碼",
    onlyPersian: "僅允許波斯字母！",
    cardNumberLength: "卡號必須為 16 位！",
    shebaLength: "Sheba 號碼必須為 24 位！",
  },
  USER_PICKER: {
    SELECT_USER: "選擇用戶",
    SELECT_USERS: "選擇用戶",
    SEARCH: "搜尋",
    PERSON: "自然人",
    COMPANY: "法人",
    ID: "ID",
    NAME: "姓名",
    LASTNAME: "姓氏",
    USERNAME: "用戶名",
    PHONE: "電話",
    TYPE: "用戶類型",
  },
  NEWS: {
    TITLE: "SMS Land 新聞",
    VIEW_BUTTON: "查看",
    NO_NEWS: "沒有新新聞。",
    FETCH_ERROR: "獲取新聞時出錯！",
  },
  MENUS: {
    CONTACT_LIST: "聯絡人清單",
    FINDPREFIX: "查找前綴",
    // 系統
    TICKET_REGISTRATION: "註冊票據",
    AD_TERMINAL_SYSTEM: "大型廣告終端系統",
    WALLET_TRANSACTIONS: "錢包交易",
    DYNAMIC_QR_SYSTEM: "動態 QR 創建系統",
    DIVAR_AD_SYSTEM: "Divar 廣告發布和管理系統",
    GRAPHIC_DESIGN_SYSTEM: "圖形設計和印刷訂單系統",
    DIGITAL_MARKETING_SYSTEM: "數位行銷管理系統",
    BULK_SMS_SYSTEM: "批量簡訊發送系統",
    BUSINESS_INFO_SYSTEM: "國家職業資訊庫系統",
    AD_MANAGEMENT_SYSTEM: "廣告管理系統",
    GRAPHIC_VIDEO_SERVICES: "圖形設計和影片服務系統",
    // QR 工具
    QR_TOOL: "QR 工具",
    CREATE_DYNAMIC_QR: "創建動態 QR",
    QR_MANAGEMENT: "QR 管理",
    QR_MONITORING: "QR 監控",
    MY_QR_LIST: "我的 QR 清單",
    PHYSICAL_NFC_ORDERS: "實體卡和 NFC 訂單",
    BULK_QR_GENERATION: "批量 QR 創建",
    IMAGE_CREATION_TOKEN: "圖像創建令牌",
    QR_SMS: "QR 簡訊",
    QR_LINK: "QR 連結",
    QR_TEXT: "QR 文字",
    QR_LOCATION: "QR 位置",
    QR_EMAIL: "QR 電子郵件",
    QR_CALL: "QR 通話",
    QR_WIFI: "QR Wi-Fi",
    VISIT_STATISTICS: "訪問統計",
    // 廣告管理
    AD_MONITORING: "廣告監控",
    DIVAR_NEWS: "Divar 新聞",
    REAL_ESTATE_AD_SUBMISSION: "房地產面板廣告發布",
    AUTO_AD_RENEWAL: "廣告自動續訂",
    GRADUAL_AD_SUBMISSION: "分階段廣告發布",
    SMART_AD_SUBMISSION: "智能廣告發布",
    DEFAULT_AD_REGISTRATION: "預設廣告註冊",
    AD_ANALYZER: "廣告訪問分析器",
    ADD_AD_PHOTO: "添加廣告照片",
    SMART_LADDER: "智能階梯",
    GRADUAL_LADDER: "分階段階梯",
    ADS_LIST: "廣告清單",
    AD_REPORTS: "廣告報告",
    SCHEDULED_AD_SUBMISSION: "定時廣告發布",
    SCHEDULED_AD_LIST: "定時廣告清單",
    PERSONAL_AD_SUBMISSION: "個人廣告發布",
    TARGET_TOOLS: "目標工具",
    SMART_LIST: "智能/分階段清單",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "發送到客戶俱樂部",
    BULK_SMS: "批量簡訊",
    LIVE_SMS: "即時簡訊（舊版）",
    SEND_TO_BUSINESSES: "發送到國家職業",
    SMS_BY_MAP: "從地圖發送簡訊",
    CITY_PROVINCE_SMS: "城市和省份發送",
    RECEIVED_SMS_LIST: "接收簡訊清單",
    SMS_TEXT_CONSULTANT: "簡訊文字顧問監控",
    DEFAULT_TEXT_CONSULTATION: "預設文字 + 諮詢",
    ADMIN_SMS_SUBMISSIONS: "管理員發送",
    PENDING_SMS: "待批准簡訊",
    ADMIN_RECEIVED_REPORT: "管理員接收報告",
    PATTERN: "模板/Pattern",
    SMS_REPORTS: "發送報告",
    DEDICATED_LINE_REQUESTS: "專用線路請求",
    PHONEBOOK: "電話簿",
    SMS_TARIFFS: "簡訊資費",
    LINE_CATEGORIES: "線路類別",
    TARIFF_COEFFICIENTS: "發送資費係數",
    SEND_ADMIN_SMS: "管理員簡訊發送",
    // 號碼和聯絡人
    ADD_NEW_NUMBER: "添加新號碼",
    NUMBERS: "號碼",
    USER_NUMBERS: "用戶號碼",
    REGISTER_USER_NUMBER: "為用戶註冊號碼",
    NUMBER_LIST: "我的號碼清單",
    CREATE_NUMBER_TARIFF: "創建號碼資費",
    NUMBER_TARIFF_LIST: "號碼資費清單",
    OTHER_TARIFF_LIST: "其他資費清單",
    // 財務管理
    WALLET: "新錢包",
    TRANSFER_REQUESTS: "提現請求",
    DIVAR_PAYMENTS: "Divar 支付",
    AUTO_PAYMENT: "自動支付",
    PAYMENTS: "支付",
    PAYMENT_GATEWAY: "支付閘道",
    BUY_CHARGE: "購買充值",
    // 客戶和用戶管理
    CUSTOMERS: "客戶",
    CRM_CUSTOMERS: "CRM 客戶",
    CONTACT_LIST: "聯絡助手（聯絡感謝）",
    USERS: "用戶清單",
    USER_REQUESTS: "用戶請求",
    PROFILE: "個人資料",
    USER_HISTORY_NOTIFICATIONS: "用戶歷史通知",
    // 設計和內容
    WEBSITE_DESIGN_ORDER: "網站設計訂單",
    SEO_ORDER: "網站 SEO 訂單",
    BUY_INFO_DATABASE: "購買資訊庫",
    BUY_MOBILE_DATABASE: "購買手機號碼庫",
    PURCHASED_ARCHIVES: "已購檔案",
    FAVORITE_ARCHIVES: "收藏檔案",
    UPLOAD_CENTER: "上傳中心",
    CONTENT: "內容",
    // 管理和設定
    MONITORING: "監控",
    MANAGEMENT: "管理",
    SETTINGS: "設定",
    CATEGORIES: "類別",
    DOMAINS: "域名",
    REMINDERS: "提醒",
    AUTOMATIC_CREATION: "自動創建",
    PERMISSIONS: "權限",
    ROLES: "角色",
    MENUS: "選單",
    CORE_MANAGEMENT: "核心管理",
    WORK_REPORTS: "工作報告管理",
    WORK_REPORT_CREATE: "工作報告",
    DEPARTMENTS: "部門",
    DISCOUNTS: "折扣",
    NOTIFICATIONS: "通知",
    ADMIN_NOTIFICATIONS: "管理員通知",
    TICKET_MANAGEMENT: "票據管理",
    USER_GUIDE: "用戶指南",
    CAMPAIGN: "活動",
    MESSAGE_CATEGORIES: "訊息類別",
    REGISTERED_INFO_LIST: "註冊資訊清單",
    TARIFFS: "資費",
    INFORMATION_REGISTRATION: "資訊註冊",
    UNCREATED_CARDS: "未創建卡片",
    MODELS_LIST: "模型清單",
    CREATE_DEFAULT_PRODUCT: "創建預設產品",
    EXCEL_FILES: "Excel 檔案",
    AUTO_CHATS: "智能聊天",
    AUTO_CHAT: "自動聊天",
    // 其他
    MY_FILES: "我的檔案",
    CONSULTANTS: "顧問",
    ADD_DIVAR_NEWS: "添加 Divar 新聞",
    BUY_PANEL: "購買面板",
    PANELS: "面板",
    CALL_MONITORING: "通話監控",
    INFO_REVIEW: "資訊審查",
    MESSAGES: "訊息",
    PERSONNEL: "員工",
    //qr
    QR_TOOL: "QR 工具",
    CREATE_DYNAMIC_QR: "創建動態 QR",
    QR_MANAGEMENT: "QR 管理",
    QR_MONITORING: "QR 監控",
    MY_QR_LIST: "我的 QR 清單",
    PHYSICAL_NFC_ORDERS: "實體卡和 NFC 訂單",
    BULK_QR_GENERATION: "批量 QR 創建",
    IMAGE_CREATION_TOKEN: "圖像創建令牌",
    CATEGORIES: "類別",
    CREATE_DEFAULT_PRODUCT: "創建預設產品",
    DOMAINS: "域名",
    REMINDERS: "提醒",
    AUTOMATIC_CREATION: "自動創建",
    SEND_ADMIN_SMS: "管理員簡訊發送",
    UNCREATED_CARDS: "未創建卡片",
    MODELS_LIST: "模型清單",
    UPLOAD_CENTER: "上傳中心",
    INFORMATION_REGISTRATION: "資訊註冊",
    TARIFFS: "資費",
    REGISTERED_INFO_LIST: "註冊資訊清單",
    //code
    personel: "員工",
    "workReports/create": "工作報告",
    "admin/user-guide": "用戶指南",
    phonebook: "客戶俱樂部",
    contactlist: "聯絡助手（聯絡感謝）",
    "contact/list": "聯絡助手（聯絡感謝）",
    "admin/transferRequests": "提現請求",
    "admin/wallet": "新錢包",
    "admin/cdr": "通話監控",
    "admin/campaign": "活動",
    "admin/message-categories": "訊息類別",
    "admin/customers": "CRM 客戶",
    "admin/notifications": "管理員通知",
    "admin/user-history/notifications": "用戶歷史通知",
    "admin/messages": "訊息",
    profile: "個人資料",
    "admin/workReports": "工作報告管理",
    panel: "購買面板",
    adminDiscounts: "折扣",
    departments: "部門",
    adminTickets: "票據管理",
    "admin/configs": "設定",
    notifications: "通知",
    "user/confirmed": "用戶請求",
    users: "用戶清單",
    payments: "支付閘道",
    permission: "權限",
    panels: "面板",
    category: "選單",
    content: "內容",
    role: "角色",
    "core/admin": "核心管理",
    //robot
    numberList: "我的號碼清單",
    registerAd: "註冊廣告",
    proPanelSendAd: "專業面板廣告發布",
    buyCharge: "購買充值",
    scheduledAdSend: "定時廣告發布",
    smartGradual: "智能/分階段",
    createNumberTariff: "創建號碼資費",
    numberTariffList: "號碼資費清單",
    otherTariffList: "其他資費清單",
    userNumbers: "用戶號碼",
    numbers: "號碼",
    management: "管理",
    settings: "設定",
    registerUserNumber: "為用戶註冊號碼",
    divarPayments: "Divar 支付",
    autoPayment: "自動支付",
    adAnalyzer: "廣告訪問分析器",
    infoReview: "資訊審查",
    rb_payments: "支付",
    autoChat: "自動聊天",
    ads: "廣告",
    monitoring: "監控",
    smartLadder: "智能階梯",
    gradualLadder: "分階段階梯",
    excelFiles: "Excel 檔案",
    autoChats: "智能聊天",
    addAdPhoto: "添加廣告照片",
    targetTools: "目標工具",
    smartList: "智能/分階段清單",
    scheduledAdList: "定時廣告清單",
    adsList: "廣告清單",
    adReports: "廣告報告",
    personalAdSend: "個人廣告發布",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "輸入您想要的時間：",
    SUBTITLE: "設定時間後，此頁面將按選定時間自動刷新。",
    TIME_LABEL: "時間",
  },
  MODAL: {
    OK_TITLE: "確認",
  },

  ROUTE: {
    TITLES: {
      QR_LUCK_WHEEL_Edit: "編輯幸運轉盤",
      DASHBOARD: "儀表板",
      ADMIN_QR_DOMAINS: "域名監控",
      ADMIN_TOGETHER_TOKEN: "令牌監控",
      ADMIN_QR_SMS: "簡訊發送",
      MENU_PROFILE_INFO: "用戶資訊",
      MENU_PROFILE_SETTING: "個人資料設定",
      MENU_PROFILE_ORDERS: "訂單",
      MENU_PROFILE_ADDRESSES: "地址",
      QR_MONITORING: "QR 監控",
      QR_LIST: "我的 QR 清單",
      QR_NAME_LIST: "參與管理",
      QR_GENERATE_MULTIPLE: "批量 QR 創建",
      QR_CARD_VISIT: "創建名片",
      HELP_INFO: "按鈕測試",
      QR_MENU: "商店選單",
      QR_APPOINTMENT: "預約",
      QR_INSURANCE: "創建線上保險",
      QR_BPAGE: "創建業務頁面",
      QR_CPAGE: "創建商業/行政綜合體網站",
      QR_BSHOP: "線上商店",
      QR_NAME_EDIT_BSHOP: "編輯線上商店",
      QR_LINK_EDIT: "編輯連結",
      QR_NAME_DESIGN: "編輯設計",
      QR_NAME_SETTING: "編輯設定",
      QR_NAME_EDIT: "編輯名片",
      QR_NAME_EDIT_BPAGE: "編輯業務頁面",
      QR_EDIT_CPAGE: "編輯綜合體網站",
      QR_NAME_INSURANCE: "編輯線上保險",
      QR_NAME_EDIT_MENU: "編輯選單",
      QR_NAME_EDIT_APPLICATION: "應用展示",
      QR_NAME_EDIT_APPOINTMENT: "編輯預約",
      QR_NAME_EDIT_PHOTO: "編輯照片圖庫",
      QR_NAME_EDIT_VIDEO: "編輯影片圖庫",
      QR_NAME_EDIT_VOICE: "編輯語音圖庫",
      QR_NAME_EDIT_FEEDBACK: "編輯回饋圖庫",
      QR_NAME_CONSULTATION_QR_EDIT: "編輯請求表單",
      QR_NAME_EDIT_VOICE_PRO: "編輯語音圖庫（專業版）",
      QR_NAME_EDIT_SOCIAL: "編輯社交媒體",
      QR_NAME_STATISTICS: "QR 碼統計",
      QR_CATE: "選擇類別",
      QR_SHARE: "共享",
      QR_BUSINESS_SHOP: "業務/商店",
      QR_CO_ORGAN: "公司/組織",
      QR_CONTACT: "客戶聯絡",
      QR_NOTICES: "通知",
      QR_OTHERS: "其他",
      QR_STATICS: "靜態 QR",
      QR_DYNAMICS: "動態 QR",
      QR_D_BUSINESS: "動態業務 QR",
      QR_D_ORGANS: "動態組織 QR",
      QR_D_GOVERNMENT: "動態政府 QR",
      QR_VIDEO: "影片圖庫",
      QR_APPLICATION: "應用展示",
      QR_VOICE: "語音圖庫",
      QR_VOICE_PRO: "語音圖庫（專業版）",
      QR_CONSULTATION_QR: "請求表單",
      QR_FEEDBACK: "回饋圖庫",
      QR_PHOTO: "照片圖庫",
      QR_CATALOG: "目錄 / 宣傳冊",
      QR_LOCATION: "創建位置 QR",
      QR_SOCIAL_MEDIA: "創建社交媒體 QR",
      QR_LINK: "創建連結",
      QR_TEXT: "創建文字",
      QR_MAIL: "創建電子郵件",
      QR_CALL: "通話",
      QR_SMS: "簡訊",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "網站",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "業務頁面",
      QR_DISCOUNT: "折扣頁面",
      QR_PRODUCT_SHOP: "產品介紹",
      QR_PRODUCT_LABEL: "產品標籤",
      QR_GOLD_LABEL: "黃金標籤",
      QR_PRODUCT_TEMPLATE: "產品",
      ADMIN_CATEGORY: "類別",
      QR_NFC_ORDERS: "待批准 NFC 卡",
      QR_NAME_PRODUCT: "編輯產品介紹",
      QR_NAME_LABELPRODUCT: "編輯產品標籤",
      QR_NAME_GOLDPRODUCT: "編輯黃金標籤",
      QR_COINS: "加密貨幣",
      QR_SHOP: "商店管理",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "上傳中心",
      PRICING: "QR 資費",
      QR_CREATE_MODELS: "創建名片模型",
      QR_CREATE_BUSINESS_MODELS: "創建業務頁面模型",
      QR_CREATE_PRODUCT_MODEL: "創建產品卡模型",
      QR_CREATE_MENU_MODELS: "創建商店選單模型",
      QR_CREATE_SHOP_MODEL: "創建線上商店模型",
      MODELS_LIST: "QR 模型類型",
      MODELS_LIST_EDIT: "編輯模型",
      MODELS_LIST_MENU_EDIT: "編輯選單模型",
      MODELS_LIST_BMODEL_EDIT: "編輯線上商店模型",
      NFC: "NFC 卡",
      SUBMIT_FORM: "註冊部落客",
      REQUEST_LIST: "部落客清單",
      PURE_DATA: "未創建名片清單",
      AUTO_CREATE: "自動 QR 創建",
      QR_CREATE: "創建 QR",
      HISTORY_REMINDER: "提醒監控",
      BOOK: "提醒監控",
    },
  },
  qr_management: "QR 管理",
  router: {
    QR_LUCK_WHEEL: "建立運氣轉盤 QR 碼",
    dashboard: "儀表板",
    contacts: "客戶俱樂部",
    editContact: "編輯客戶",
    createContact: "創建客戶",
    customers: "客戶清單",
    contactList: "聯絡助手",
    messages: "訊息",
    messageCategories: "訊息類別",
    oldTransactions: "舊交易",
    yourTransactions: "您的交易",
    buyPanel: "購買面板",
    permissions: "權限",
    createPermission: "創建權限",
    invitations: "我的邀請清單",
    editUser: "編輯用戶",
    userInformation: "查看用戶資訊",
    walletEdit: "編輯用戶錢包資訊",
    userHistory: "用戶歷史",
    userNotificationsHistory: "用戶通知歷史",
    notifications: "通知",
    createNotification: "創建通知",
    editNotification: "編輯通知",
    adminNotifications: "管理員通知",
    yourNotifications: "您的通知",
    adminNotificationsList: "管理員通知清單",
    tickets: "票據",
    createTicket: "註冊新票據",
    editTicket: "編輯票據",
    departments: "部門",
    createDepartment: "新建部門",
    editDepartment: "編輯部門",
    adminTickets: "票據管理",
    discounts: "折扣",
    createDiscount: "創建折扣",
    editDiscount: "編輯折扣",
    workReports: "工作報告",
    createWorkReport: "創建工作報告",
    callMonitoring: "通話監控",
    adminWorkReports: "工作報告管理",
    editWorkReport: "查看並編輯工作報告",
    packProperties: "套餐屬性",
    createPackProperty: "創建套餐屬性",
    editPackProperty: "編輯套餐屬性",
    panels: "面板",
    createPanel: "創建面板",
    editPanel: "編輯面板",
    transferRequests: "提現請求",
    editTransferRequest: "編輯提現請求",
    tariffs: "資費",
    createTariff: "創建資費",
    editTariff: "編輯資費",
    requests: "請求",
    viewUser: "查看用戶",
    manageTransactions: "交易管理",
    viewTransaction: "查看交易",
    manageConfigs: "設定管理",
    rbLandConfigs: "Robot Land 設定管理",
    editConfig: "編輯設定",
    manageUsers: "用戶管理",
    categories: "類別",
    createCategory: "添加類別",
    editCategory: "編輯類別",
    content: "內容",
    createContent: "添加內容",
    editContent: "編輯內容",
    addUserGuide: "添加用戶指南",
    editUserGuide: "編輯用戶指南",
    roles: "角色",
    editRole: "編輯角色",
    createRole: "添加角色",
    permissionTitle: "權限",
    paymentGateways: "支付閘道",
    editPaymentGateway: "編輯支付閘道",
    campaigns: "活動",
    createCampaign: "創建活動",
    editCampaign: "編輯活動資訊",
    adminCustomers: "客戶",
    createCustomer: "創建客戶",
    editCustomerInfo: "編輯客戶資訊",
    referrerCustomers: "推薦客戶",
    customerHistory: "客戶歷史",
    userProfile: "用戶個人資料",
    editProfile: "編輯個人資料",
    inviteFriends: "邀請朋友",
    personalInfo: "個人資訊",
    editPersonalInfo: "編輯資訊",
    changePassword: "更改密碼",
    newWallet: "新錢包",
  },
  ticket: {
    text: "註冊票據",
  },
};
